import { FormattedOption } from 'types/dictionaries';
import toLowerCaseLabel from './toLowerCaseLabel';

const formatOptionsWithLabel = (
  options: FormattedOption[]
): FormattedOption[] => {
  return options.map((option) => ({
    ...option,
    label: toLowerCaseLabel(option.label)
  }));
};

export default formatOptionsWithLabel;
